import React from "react";
import MaterialTableRtl from "../../UI/MaterialTableRtl/MaterialTableRtl";
import { client } from "../../../service/ApolloClient/ApolloClient";
import { QUERY_LEGAL_ENTITIES } from "../../../service/ApolloClient/ApolloQueries";
import { MUTATION_REMOVE_LEGAL_ENTITY } from "../../../service/ApolloClient/ApolloMutation";
import { SuccessToast } from "../../../hoc/ToastNotify/ToastNotify";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { confirmAlert } from "react-confirm-alert"; // Import

class LegalEntityList extends React.Component {
  tableRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      data: [],
      columns: [
        {
          title: "#",
          field: "id",
          render: (rowData) => {
            return (
              <a href={`/legal-entity/edit/${rowData.id}`}>{rowData.id}</a>
            );
          },
        },
        {
          title: "نام",
          field: "name",
          render: (rowData) => rowData.name,
        },

        {
          title: "ایمیل",
          field: "email",
          render: (rowData) => rowData.email,
        },
        {
          title: "تلفن",
          field: "phone",
          render: (rowData) =>
            JSON.parse(rowData.phone)
              ? JSON.parse(rowData.phone).join(",")
              : "",
        },

        {
          title: "همراه",
          field: "mobile",
          render: (rowData) =>
            JSON.parse(rowData.mobile)
              ? JSON.parse(rowData.mobile).join(",")
              : "",
        },
      ],
    };

    this.remoteData = this.remoteData.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  componentDidMount() {
    // this.fetchData();
  }

  remoteData = (query) => {
    return client
      .query({
        query: QUERY_LEGAL_ENTITIES,
        variables: {
          page: query.page + 1,
          limit: query.pageSize,
          search: query.search,
          orderBy: query.orderBy ? query.orderBy.field : null,
          orderDirection: query.orderDirection,
          user: this.props.user,
        },
        fetchPolicy: "network-only",
      })
      .then((res) => {
        let data = structuredClone(res.data);
        return {
          data: data.legalEntities.data,
          page: query.page,
          totalCount: data.legalEntities.total,
        };
      });
  };

  handleRemove = (id) => {
    confirmAlert({
      title: "تاییدیه حذف",
      message: "آیا واقعا می خواهید حذف کنید.",
      buttons: [
        {
          label: "بله",
          onClick: () => {
            client
              .mutate({
                mutation: MUTATION_REMOVE_LEGAL_ENTITY,
                variables: {
                  id: id,
                },
              })
              .then((res) => {
                let d = res.data.removeLegalEntity;
                this.tableRef.current.onQueryChange();
                SuccessToast("با موفقیت حذف گردید");
              })
              .catch((err) => console.log(err));
          },
        },
        {
          label: "بی خیال",
          onClick: () => {},
        },
      ],
    });
  };

  render() {
    const { columns, data } = this.state;
    let title = "افراد حقوقی" + " " + (this.props.name ? this.props.name : "");
    return (
      <MaterialTableRtl
        tableRef={this.tableRef}
        columns={columns}
        data={this.remoteData}
        editLink={"/legal-entity/edit/"}
        handleRemove={this.handleRemove}
        needExport={true}
        title={title}
        pdfName={this.props.pdfName ? this.props.pdfName : title}
      />
    );
  }
}

export default LegalEntityList;
